import { useRef } from 'react';

const FJDragBox = props => {
    const { setIsDragging, uploadFile, children, className, multipleUpload = false, style, disable = false } = props;
    const boxRef = useRef(null);
    const _onDragOver = e => {
        if (disable) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDragging && setIsDragging(true);
    };

    const _onDragLeave = e => {
        if (disable) return;
        e.stopPropagation();
        e.preventDefault();
        if (!boxRef.current) return;
        const rect = boxRef.current.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
            setIsDragging && setIsDragging(false);
        }
    };
    const _onDragDrop = e => {
        if (disable) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDragging && setIsDragging(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            if (multipleUpload) {
                let files = Array.from(e.dataTransfer.files);
                uploadFile(files);
            } else {
                const file = files[0];
                uploadFile && uploadFile(file);
            }
        }
    };
    return (
        <div
            className={className}
            onDragOver={_onDragOver}
            onDragLeave={_onDragLeave}
            onDrop={_onDragDrop}
            ref={boxRef}
            style={style}
        >
            {children}
        </div>
    );
};

export default FJDragBox;
